var function_group = {
    lastPan: null,
    functionID: "",
    function_group_IsSliding: false
};

function_group.init = function ($root) {
    function_group.function_group_IsSliding = false;
    function_group.functionID = $("[data-role='content-body']", $root).attr("data-function-id");
    var $functionList = $("[data-role='function-group']", $root);

    function_group.lastPan = null;

    if ( $functionList.length > 1 ) {
        $("[data-role=content]").attr("data-multifunction","true")
        $("[data-role=content]").append("<div id='nb_slide'></div>")
        $functionList.each(function(){
            $("#nb_slide", $root).append("<span class='bullet'/>")
        })

        var queryDictionnary = URI().query(true);

        var storedIdFunctionGroup = queryDictionnary.idFunctionGroup;

        if ( storedIdFunctionGroup == undefined ) {
            queryDictionnary = URI(pap.currentPage).query(true);
            storedIdFunctionGroup = queryDictionnary.idFunctionGroup;
        }

        function_group.saveHistorique(storedIdFunctionGroup);
        function_group.select(storedIdFunctionGroup, $root);

        $("[data-role='content-body']", $root).hammer({recognizers: [[Hammer.Pan, {direction: Hammer.DIRECTION_HORIZONTAL, threshold: 60}]]})
            .on("panstart pancancel", function(theEvent) {
                function_group.lastPan = null;
            })
            .on("panend", function(theEvent) {
                if ( (theEvent.gesture.deltaTime < 750) && (Math.abs(theEvent.gesture.deltaX) > 2 * Math.abs(theEvent.gesture.deltaY)) && (Math.abs(theEvent.gesture.deltaX) > 60) ) {
                    switch ( function_group.lastPan ) {
                        case "panleft" :
                            if ( $(this).find(".current").next("[data-role='function-group']").length > 0 ) {
                                function_group.next($(this).find(".current"));
                            }
                            break;
                        case "panright" :
                            if ( $(this).find(".current").prev("[data-role='function-group']").length > 0 ) {
                                function_group.previous($(this).find(".current"));
                            }
                            break;
                    }
                }
                function_group.lastPan = null;
            })
            .on("panleft panright", function(theEvent) {
                function_group.lastPan = theEvent.type;
            });
    } else if ( $functionList.length == 1 ) {
        var listIdFunctions = $($root).find("[data-id-function-group]");
        var firstIdFunction = $(listIdFunctions).eq(0).attr("data-id-function-group");
        $("[data-role=content]").attr("data-multifunction","false")
        function_group.select(firstIdFunction, $root);
    }else {
       /* $(".contentScrollable", $root).append("<div id='nb_slide' style='height:0px;'></div>")*/
        $("[data-role=content]").attr("data-multifunction","false")


    }
}

function_group.razScroll = function () {
    scrollController.razScroll();
}

function_group.updateRetina = function () {
    pap.retinaLoadInContext($("#content"));
}

function_group.select = function (idGroupFunction, $root) {
    var index = 0;
    if ( idGroupFunction == null || idGroupFunction == undefined || idGroupFunction == "" ) {
        var listIdFunctions = $($root).find("[data-id-function-group]");
        idGroupFunction = $(listIdFunctions).eq(0).attr("data-id-function-group");
    }
    else {
        var listIdFunctions = $($root).find("[data-id-function-group]");
        for ( var i = 0; i < listIdFunctions.length; i++ ) {
            if ( $(listIdFunctions).eq(i).attr("data-id-function-group") == idGroupFunction ) {
                index = i;
                break;
            }
        }
    }

    function_group.razScroll();
    $slideActuelle = $($root).find("[data-id-function-group='" + idGroupFunction + "']");
    $slideActuelle.addClass("current").css({"left" : "0"});
    $("#nb_slide .bullet", $root).eq(index).addClass("active");
    $slideActuelle.prevAll().css({"left" : "-105%"}).hide();
    $slideActuelle.nextAll().css({"left" : "-105%"}).hide();

    function_group.updateRetina();
    if ( typeof createKnobNavigation !== "undefined" ) createKnobNavigation();
    if ( typeof bindTouchEvents !== "undefined" ) bindTouchEvents();
}

function_group.previous = function ($this) {
    if ( !function_group.function_group_IsSliding ) {
        function_group.function_group_IsSliding = true;
        $previousPage = $this.prev("[data-role='function-group']");
        function_group.razScroll();
        $this.animate({
            left: "+105%"
        }, 500, function() {
            $this.removeClass("current").hide().css({"left" : "-105%"});
            $("#nb_slide .bullet").eq($this.index()).removeClass("active");
        });

        $previousPage.show();
        $previousPage.animate({
            left: "0"
        }, 500, function() {
            $(this).addClass("current");
            var currentSlide = $(this).index();
            $("#nb_slide .bullet").eq(currentSlide).addClass("active");

            var listIdFunctions = $("#content").find("[data-id-function-group]");
            var idFunctionGroup = $(listIdFunctions).eq(currentSlide).attr("data-id-function-group");

            function_group.saveHistorique(idFunctionGroup);

            function_group.function_group_IsSliding = false;
            function_group.updateRetina();
            scrollController.createScroll();
            scrollController.razScroll();
        });
    }
}

function_group.next = function ($this) {
    if ( !function_group.function_group_IsSliding ) {
        function_group.function_group_IsSliding = true;
        $nextPage = $this.next("[data-role='function-group']");
        function_group.razScroll();
        $this.animate({
            left: "-105%"
        }, 500, function() {
            $this.removeClass("current").hide();
            $("#nb_slide .bullet").eq($this.index()).removeClass("active");
        });

        $nextPage.show().css({"left" : "+105%"});
        $nextPage.animate({
            left: "0"
        }, 500, function() {
            $(this).addClass("current");
            var currentSlide = $(this).index();
            $("#nb_slide .bullet").eq(currentSlide).addClass("active");

            var listIdFunctions = $("#content").find("[data-id-function-group]");
            var idFunctionGroup = $(listIdFunctions).eq(currentSlide).attr("data-id-function-group");

            function_group.saveHistorique(idFunctionGroup);

            function_group.function_group_IsSliding = false;
            function_group.updateRetina();
            scrollController.createScroll();
            scrollController.razScroll();
        });
    }
}

function_group.saveHistorique = function(idFunctionGroup) {
    historique.idFunctionGroup = idFunctionGroup;
}
